import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Capacitor } from '@capacitor/core';
import BackButton from '../../components/BackButton';
import Icon from '../../components/AppIcon';
import { registerMobilePush, unregisterMobilePush } from '../../services/mobilePushService';

const NOTIF_KEY = 'mashhad_notifications_enabled';

/**
 * صفحة الإعدادات للزائر (غير مسجّل) — متاحة لأي شخص.
 */
export default function GuestSettings() {
  const navigate = useNavigate();
  const isNative = Capacitor.isNativePlatform();

  const [notificationsEnabled, setNotificationsEnabled] = useState(() => {
    const stored = localStorage.getItem(NOTIF_KEY);
    return stored === null ? true : stored === 'true';
  });

  const handleToggleNotifications = async (enabled) => {
    setNotificationsEnabled(enabled);
    localStorage.setItem(NOTIF_KEY, String(enabled));
    if (isNative && !enabled) {
      await unregisterMobilePush().catch(() => {});
    }
  };

  return (
    <div className="min-h-screen bg-slate-50 p-4 md:p-6" dir="rtl">
      <div className="max-w-lg mx-auto pt-8">
        <div className="mb-6">
          <BackButton to="/account" label="العودة إلى حسابي" />
        </div>

        <h1
          className="text-2xl font-bold text-slate-900 mb-1"
          style={{ fontFamily: 'IBM Plex Sans Arabic, sans-serif' }}
        >
          الإعدادات
        </h1>
        <p className="text-slate-600 text-sm mb-6">إعدادات التطبيق</p>

        <div className="space-y-6">
          {/* الإشعارات */}
          <div className="bg-white rounded-2xl shadow-sm border border-slate-200 p-6">
            <div className="flex items-center justify-between gap-3">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center flex-shrink-0">
                  <Icon name="Bell" size={20} className="text-primary" />
                </div>
                <div>
                  <h2 className="text-base font-bold text-slate-900">الإشعارات</h2>
                  <p className="text-sm text-slate-500">تلقي إشعارات الحجوزات والتحديثات</p>
                </div>
              </div>
              <button
                type="button"
                role="switch"
                aria-checked={notificationsEnabled}
                onClick={() => handleToggleNotifications(!notificationsEnabled)}
                className={`relative inline-flex h-6 w-11 flex-shrink-0 items-center rounded-full transition-colors focus:outline-none ${
                  notificationsEnabled ? 'bg-primary' : 'bg-slate-300'
                }`}
              >
                <span className={`inline-block h-4 w-4 transform rounded-full bg-white shadow transition-transform ${
                  notificationsEnabled ? 'translate-x-6' : 'translate-x-1'
                }`} />
              </button>
            </div>
          </div>

          {/* معلومات قانونية */}
          <div className="bg-white rounded-2xl shadow-sm border border-slate-200 p-6">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center">
                <Icon name="FileText" size={20} className="text-primary" />
              </div>
              <h2 className="text-lg font-bold text-slate-900">معلومات قانونية</h2>
            </div>
            <div className="grid gap-3">
              <button
                type="button"
                onClick={() => navigate('/about')}
                className="w-full flex items-center gap-4 p-4 rounded-xl border border-slate-200 hover:bg-slate-50 hover:border-slate-300 transition-colors text-right"
              >
                <div className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center flex-shrink-0">
                  <Icon name="Info" size={20} className="text-primary" />
                </div>
                <span className="font-medium text-slate-800">من نحن</span>
                <Icon name="ChevronLeft" size={18} className="text-slate-400 mr-auto" />
              </button>
              <button
                type="button"
                onClick={() => navigate('/terms')}
                className="w-full flex items-center gap-4 p-4 rounded-xl border border-slate-200 hover:bg-slate-50 hover:border-slate-300 transition-colors text-right"
              >
                <div className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center flex-shrink-0">
                  <Icon name="ScrollText" size={20} className="text-primary" />
                </div>
                <span className="font-medium text-slate-800">الشروط والأحكام</span>
                <Icon name="ChevronLeft" size={18} className="text-slate-400 mr-auto" />
              </button>
              <button
                type="button"
                onClick={() => navigate('/privacy')}
                className="w-full flex items-center gap-4 p-4 rounded-xl border border-slate-200 hover:bg-slate-50 hover:border-slate-300 transition-colors text-right"
              >
                <div className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center flex-shrink-0">
                  <Icon name="ShieldCheck" size={20} className="text-primary" />
                </div>
                <span className="font-medium text-slate-800">سياسة الخصوصية</span>
                <Icon name="ChevronLeft" size={18} className="text-slate-400 mr-auto" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
